import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useWhatsappCallsRuntime } from './WhatsappCallsRuntimeContext';
import useFonemaOnAnswer from '../fonema/actions/useFonemaOnAnswer';

export default function useWhatsappOnAnswer({ callInfoData, startActiveCall }) {
  const { provider } = useWhatsappCallsRuntime();
  const activeCall = useSelector((state) => (
    provider === 'voice' ? state.voiceReducer.activeCall : null
  ));

  const callInfoDataRef = useRef(callInfoData);
  const startActiveCallRef = useRef(startActiveCall);
  callInfoDataRef.current = callInfoData;
  startActiveCallRef.current = startActiveCall;

  useFonemaOnAnswer({
    callInfoData,
    startActiveCall,
    enabled: provider === 'fonema'
  });

  useEffect(() => {
    if (provider !== 'voice') return undefined;

    const callId = callInfoDataRef.current?.callId;
    if (!callId || activeCall?.callControlId !== callId) return undefined;

    startActiveCallRef.current({
      ...callInfoDataRef.current,
      callId: activeCall.callControlId,
      callerNumber: activeCall.from ?? callInfoDataRef.current.callerNumber
    });

    return undefined;
  }, [provider, activeCall?.callControlId, activeCall?.from]);
}
